import { render, staticRenderFns } from "./diff.vue?vue&type=template&id=d051a19e&scoped=true&"
import script from "./diff.vue?vue&type=script&lang=js&"
export * from "./diff.vue?vue&type=script&lang=js&"
import style1 from "./diff.vue?vue&type=style&index=1&id=d051a19e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d051a19e",
  null
  
)

export default component.exports